import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * OruClick People logo: circular product icon + stacked wordmark
 * (matches the OruClick Payroll browser-tab style, with "People" as the product name)
 *
 * @param {Object} props
 * @param {number|object} props.iconSize - Icon diameter (default: { xs: "32px", sm: "40px", md: "44px" })
 * @param {number|object} props.fontSize - Font size for the "People" line (default: { xs: "18px", sm: "22px", md: "24px" })
 */
export const OruClickLogo = ({
  iconSize = { xs: "32px", sm: "40px", md: "44px" },
  fontSize = { xs: "18px", sm: "22px", md: "24px" },
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: "8px", sm: "10px", md: "12px" },
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/Logo/OruClickLogo.svg`}
        alt="OruClick"
        sx={{
          width: iconSize,
          height: iconSize,
          flexShrink: 0,
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <Typography
          sx={{
            fontSize: { xs: "11px", sm: "13px", md: "14px" },
            fontWeight: 400,
            color: "text.secondary",
            letterSpacing: "0.2px",
            lineHeight: 1.2,
          }}
        >
          OruClick
        </Typography>
        <Typography
          sx={{
            fontSize: fontSize,
            fontWeight: 700,
            color: "text.primary",
            letterSpacing: "-0.2px",
            lineHeight: 1.15,
          }}
        >
          People
        </Typography>
      </Box>
    </Box>
  );
};

export default OruClickLogo;
